import React, {Component} from 'react';
import { connect } from 'react-redux';
import * as accountActions from '../../../../../actions/account/account';
import ReceiptList from './ReceiptList';
import ReceiptMemberDetails from './ReceiptMemberDetails';
import ReceiptPrintTemplate from './ReceiptPrintTemplate';
import { Loader } from "../../../../common/elements/index";

import Prismic from 'prismic-javascript';
import { RichText } from 'prismic-reactjs';
import { PrismicConfig } from '../../../../../helpers/prismicHelpers/PrismicAPI';
import { LanguagePrismicHelper }from '../../../../../helpers/prismicHelpers/PrismicHelpers';

class TransactionReceipt extends Component {

    constructor(props){
        super(props);
        this.state = {
            isReceipt: false,
            companyDetails: '',
        };
    }

    async componentWillMount() {
        
        const languagePrismic = LanguagePrismicHelper();
        
        try {
            const res = await Prismic.api( PrismicConfig.apiEndpoint, { apiAccessToken : PrismicConfig.apiAccessToken } );
            const json = await res.query(Prismic.Predicates.at( "document.type", "company-details" ), languagePrismic);
            this.setState({ companyDetails : json.results[0].data.company_details });
        }catch( err ){
            return { error : true };
        };
    }
    
    componentDidMount() {
        this.props.setTransactionReceipt( this.props.params.transactionId );
    }

    componentWillReceiveProps( nextProps ) {
        nextProps.receipt && nextProps.receipt.person.id !== parseInt( localStorage.getItem( 'person_id'), 10 ) ? this.props.history.push(`/${this.props.params.network}/account/transaction-history`) : null;
        nextProps.receipt && nextProps.receipt.id ? this.setState({isReceipt: true}) : null;
    }

    render() {
        if( !this.props.receipt ){ return <Loader/> };
        return (
            <div>
                <div id='react-no-print'>
                    <div className="receipt-background padding-xy">
                        <h3 className="h3 text-center margin-none">Thank you for your purchase</h3>
                        <h3 className="h3 text-center margin-none padding-bottom">{ this.props.receipt.person.first_name } { this.props.receipt.person.last_name }</h3>
                    </div>
                    <div className="receipt-header-arrow text-center"><i className="fa fa-caret-down"/></div>
                    <ReceiptMemberDetails account={ this.props.account }/>
                    <hr/>
                    <div>
                        <ReceiptList receipt={ this.props.receipt }  />
                    </div>
                    <hr/>
                    <div className="receipt-address">
                        { this.state.companyDetails && RichText.render(this.state.companyDetails) }
                    </div>
                </div>
                <ReceiptPrintTemplate company={ this.state.companyDetails } details={ this.props.form } receipt={ this.props.receipt } currency={ this.props.receipt.basket.currency }  />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    receipt: state.account.transactionReceipt,
    account: state.account.account,
    form: state.form.receipt_member_details,
});

const mapDispatchToProps = dispatch => ({
    setTransactionReceipt: transactionId => dispatch(accountActions.setTransactionReceipt( transactionId )),
});

export default connect( mapStateToProps, mapDispatchToProps )( TransactionReceipt );



// WEBPACK FOOTER //
// src/client/components/site/features/account/transactionHistory/TransactionReceipt.js